import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByString',
  standalone: true
})
export class SortByStringPipe implements PipeTransform {
  transform<T extends object>(
    array: T[],
    key: keyof T,
    order: 'asc' | 'desc' = 'asc',
    fallbackKey?: keyof T
  ): T[] {
    if (!array) return array;

    // If key not present, use fallback
    if (array.length > 0 && !(key in array[0]) && fallbackKey) {
      key = fallbackKey;
    }

    return [...array].sort((a, b) => {
      let valueA = a[key];
      let valueB = b[key];

      if (valueA == null) return order === 'asc' ? -1 : 1;
      if (valueB == null) return order === 'asc' ? 1 : -1;

      // natural sorting
      const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'base'
      });

      const result = collator.compare(valueA.toString(), valueB.toString());
      return order === 'asc' ? result : -result;
    });
  }
}
